export default "__VITE_ASSET__CccT9VnH__"